import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CreatableSelect from 'react-select/creatable';
import DropdownIndicator from '../DropdownIndicator';
import './MultiSelectCreatableTextInput.scss';

const components = (showDropdownIndicator) => ({
  DropdownIndicator: showDropdownIndicator ? DropdownIndicator : () => null,
  IndicatorSeparator: () => null,
});

const createOption = (label) => ({
  label,
  value: `custom:${label}`,
});

class MultiSelectCreatableTextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(values, actionMeta) {
    const { handleCustomSelectChange } = this.props;
    handleCustomSelectChange(values, actionMeta.action);
  }

  handleInputChange(value) {
    this.setState({ inputValue: value });
  }

  handleKeyDown(event) {
    const { handleCustomSelectChange } = this.props;
    const { inputValue } = this.state;

    if (event.key === 'Backspace' && !inputValue) {
      handleCustomSelectChange(this.props.values, 'delete-value-key');
      event.preventDefault();
      return;
    }

    if (!inputValue) return;

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        handleCustomSelectChange(createOption(inputValue));
        this.setState({ inputValue: '' });
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  render() {
    const {
      values, isDisabled, enterPrompt, showDropdownIndicator,
    } = this.props;
    const { inputValue } = this.state;
    return (
      <div className="mb-3">
        <CreatableSelect
          components={components(showDropdownIndicator)}
          inputValue={inputValue}
          isClearable
          isMulti
          menuIsOpen={false}
          placeholder={enterPrompt ? 'Type here and press Enter after each item' : 'Enter...'}
          onInputChange={this.handleInputChange}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          value={values}
          isDisabled={isDisabled}
          classNamePrefix="body-text-2 clora-multiselect clora-multiselect-custom"
        />
        { enterPrompt
          && (
          <div className="mt-3 body-text-3 orange-warning-text">
            <i className="me-2 fa fa-exclamation-triangle" />
            <strong>Press Enter</strong>
            {' '}
            after typing each item.
          </div>
          )}
      </div>
    );
  }
}

MultiSelectCreatableTextInput.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({})),
  handleCustomSelectChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  enterPrompt: PropTypes.bool,
  showDropdownIndicator: PropTypes.bool,
};

MultiSelectCreatableTextInput.defaultProps = {
  values: [],
  isDisabled: false,
  enterPrompt: false,
  showDropdownIndicator: true,
};

export default MultiSelectCreatableTextInput;
